import React, { useState } from 'react';
import './ImageUpload.css';
import { getApiBaseUrl } from '../config';

function ImageUpload({ label, currentImage, onImageUpload, fieldName, token }) {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      setUploadError('Please select a valid image file (PNG, JPG, GIF, WebP)');
      return;
    }

    // Validate file size (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      setUploadError('File size must be less than 5MB');
      return;
    }

    setUploadError('');
    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const apiUrl = getApiBaseUrl();
      const response = await fetch(`${apiUrl}/api/admin/upload-image`, {
        method: 'POST',
        headers: token ? { 'Authorization': `Bearer ${token}` } : {},
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        onImageUpload(fieldName, data.url);
        setIsUploading(false);
      } else {
        setUploadError(data.error || 'Upload failed');
        setIsUploading(false);
      }
    } catch (error) {
      setUploadError(`Upload error: ${error.message}`);
      setIsUploading(false);
    }
  };

  return (
    <div className="image-upload-group">
      <label className="image-upload-label">{label}</label>
      
      <div className="image-upload-container">
        {currentImage ? (
          <div className="image-preview">
            <img src={currentImage} alt={label} />
            <button
              type="button"
              className="image-remove-btn"
              onClick={() => onImageUpload(fieldName, null)}
              title="Remove image"
            >
              ✕
            </button>
          </div>
        ) : (
          <div className="image-placeholder">
            <div className="placeholder-icon">🖼️</div>
            <div className="placeholder-text">No image uploaded</div>
          </div>
        )}

        <div className="image-upload-input-wrapper">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={isUploading}
            id={`image-upload-${fieldName}`}
            className="image-upload-input"
          />
          <label htmlFor={`image-upload-${fieldName}`} className="image-upload-button">
            {isUploading ? 'Uploading...' : 'Choose Image'}
          </label>
        </div>
      </div>

      {uploadError && <div className="image-upload-error">{uploadError}</div>}
    </div>
  );
}

export default ImageUpload;